import Vue from 'vue'
import { mediaPreview } from '@core/directives/mediaPreview'

Vue.directive('media-preview', mediaPreview)
